import React from 'react';
import pageNotFound from '../../assets/page_not_found.svg';
import TopNav from '../../components/top-nav/TopNav';
import Footer from '../../components/Footer';

const PageNotFound = () => {
  return (
    <>
      <TopNav />
      <div className="wrapper">
        <div className="container">
          <img src={pageNotFound} alt="404" className="image" />
          <h1>Page not found</h1>
        </div>
      </div>
      <Footer />

      <style jsx>{`
        .wrapper {
          width: 100%;
          max-width: 500px;
          margin: auto;
          text-align: center;
          display: flex;
          height: 100vh;
          align-items: center;
        }
        .container {
          width: 100%;
        }
        .image {
          width: 100%;
          height: auto;
        }
      `}</style>
    </>
  );
};

export default PageNotFound;
